(function () {

  const isLoggedIn = document.body.classList.contains('customer-logged-in');

  // Enterprise theme selectors
  const priceBlock = document.querySelector('.product__price');
  const atcBtn     = document.querySelector('.product-form__cart-submit');
  const dcoButtons = document.querySelector('.product-form__payment-button-container');
  const wrapper    = () => document.querySelector('.map-price-wrapper');

  function applyMapState(variant) {
    const isMAP = variant.compare_at_price && variant.compare_at_price > variant.price;

    if (!isMAP) {
      // No MAP — restore normal display
      wrapper()?.style.setProperty('display', 'none');
      priceBlock?.removeAttribute('style');
      atcBtn?.removeAttribute('style');
      dcoButtons?.removeAttribute('style');
      return;
    }

    // MAP active — hide native price + buttons
    priceBlock?.style.setProperty('display', 'none', 'important');
    atcBtn?.style.setProperty('display', 'none', 'important');
    dcoButtons?.style.setProperty('display', 'none', 'important');
    wrapper()?.removeAttribute('style');

    // Update displayed prices on variant switch
    const w = wrapper();
    if (!w) return;

    if (isLoggedIn) {
      w.querySelector('.map-price__real-price').textContent =
        formatMoney(variant.price);
      w.querySelector('.map-price__compare s').textContent =
        formatMoney(variant.compare_at_price);
    } else {
      w.querySelector('.map-price__map-price').textContent =
        formatMoney(variant.compare_at_price);
    }
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  // Enterprise theme variant change event
  document.addEventListener('theme:variant:change', (e) => {
    if (e.detail?.variant) applyMapState(e.detail.variant);
  });

  // Fallback: MutationObserver on hidden variant input
  const variantInput = document.querySelector('input[name="id"]');
  if (variantInput) {
    new MutationObserver(() => {
      const variantId = variantInput.value;
      // Read from window.theme.product if available (Enterprise exposes this)
      const variant = window?.theme?.product?.variants?.find(
        v => v.id == variantId
      );
      if (variant) applyMapState(variant);
    }).observe(variantInput, { attributes: true, attributeFilter: ['value'] });
  }

})();
